import React from "react";
import "./subscription-summary.css";
import Button from "app/components/button/Button";
import SwitchButton from "app/components/switchbutton/SwitchButton";
import EnableAutoPay from "app/pages/enableautopay/EnableAutoPay";
import SetReminder from "app/pages/set-reminder/SetReminder";
import ImageLogo from "../../../images/boldlogo.png";

class SubscriptionSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      autoPay: false,
      reminder: false,
    };
  }

  onChange(event) {
    const value = event.target.value === "false" ? false : true;
    const name = event.target.name;
    this.setState({ [name]: value });
  }

  showAutoPay() {
    if (this.state.autoPay) return <EnableAutoPay />;
    else return null;
  }

  showSetReminder() {
    if (this.state.reminder) return <SetReminder />;
    else return null;
  }

  render() {
    const { autoPay, reminder } = this.state;
    return (
      <>
        <div className="d-flex align-items-center pb-2 brand-head">
          <div>
            <div className="default_circle border-primary align-self-center">
              <img src={ImageLogo} alt="payulogo" width="20" />
            </div>
          </div>
          <div className="brand-name">
            <h2 className="font-weight-bold darkgrey ">Hungama Music</h2>
          </div>
        </div>
        <div className="info-group">
          <div className="border-bottom-primary">
            <label>Contact Number</label>
            <p className="font-weight-bold">+91 9987258711</p>
          </div>
        </div>

        <div className=" card bg-info p-2">
          {/* <div className="info-group">
              <label>Validity</label>
              <p className="font-weight-bold">1 Year</p>
            </div> */}

          <div className="d-flex justify-content-between align-items-center">
            <div className="info-group">
              <label>Validity</label>
              <p className="font-weight-bold">1 Year</p>
            </div>
            <div className="info-group text-right">
              <label>Plan</label>
              <p className="font-weight-bold text-right">Truely Unlimited</p>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <div className="info-group">
              <label>Details:</label>
              <p className="font-weight-bold">
                Lorem ipsum dolar music amet edition for 365 days
              </p>
            </div>
          </div>
          <div className="info-group dashed-border-top">
            <label> Bill amount: </label>
            <h1 className="font_600"> ₹ 1499</h1>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center py-2">
          <p>
            <SwitchButton
              label="Enable auto pay"
              name="autoPay"
              value={autoPay}
              onChange={this.onChange}
            ></SwitchButton>
          </p>
          <p>
            <SwitchButton
              label="Set Reminder"
              name="reminder"
              value={reminder}
              onChange={this.onChange}
            ></SwitchButton>
          </p>
        </div>

        {this.showAutoPay()}
        {this.showSetReminder()}

        {!autoPay && (
          <div className="my-2">
            <Button className="button btn-primary mb-4"> Pay Now </Button>
            <Button className="button btn-primary-outline"> Done </Button>
          </div>
        )}
      </>
    );
  }
}

export default SubscriptionSummary;
